module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/c9zCtr/tc-custom/9781460349502.jpg?1738351064769",
      "alt": "This image is the cover for the book Rake's Rebellious Lady"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rake's Rebellious Lady\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this Regency romance, a dashing rake has a wild tomboy seeing marriage in a new light.")]), _c('br'), _c('br'), _vm._v("Tomboy Miss Caroline Holbrook is used to running riot and can’t imagine settling into a dull, respectable marriage. Undaunted, her aunt’s determined to see Caroline at all the best gatherings in town. Caroline’s zest for life and alluring innocence draw the attention of Sir Frederick Rathbone—who is far from dull! In fact, he’s the most exciting man Caroline has ever met. But should she resist the attentions of this rakish and most sought-after bachelor in town?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anne Herries\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin UK Ltd\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0